import { createContext, useContext } from "react";
import type { EmployeeAdvance } from "features/EmployeeAdvances/types/employee-advance.types";

interface EmployeeAdvanceOverviewContextType {
  advance: EmployeeAdvance | null;
  refetch: () => Promise<void>;
}

const EmployeeAdvanceOverviewContext =
  createContext<EmployeeAdvanceOverviewContextType | null>(null);

export const useEmployeeAdvanceOverview = () => {
  const context = useContext(EmployeeAdvanceOverviewContext);
  if (!context) {
    throw new Error("useEmployeeAdvanceOverview must be used within provider");
  }
  return context;
};

export default EmployeeAdvanceOverviewContext;
